import { Controller } from "remult";

@Controller("call-center-shift-task-methods")
export class CallCenterShiftTaskMethods {}
